import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import "../../../node_modules/@chenfengyuan/datepicker/dist/datepicker.esm";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";
import moment from "moment";
import PromoApi from "mbpromo/src/api/PromoApi";

class FormCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);

		this.userPrivacyProfiling = false;
		this.alphanumReg = /^[A-Za-z0-9 ']+$/;
		this.numberReg =  /^[0-9]+$/;
		this.centReg =  /^[0-9]{2}$/;
		this.files = [];
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});

		this.productNumber = this.element.dataset["productNumber"] || 1;
		this.alwaysOn = true;

		this.openDayTime = '';
		this.closeDayTime = '';

		this.openHour = '';
		this.closeHour = '';
		this.init();
	}

	init() {
		this.loadChildComponents(this);
		this.startLoader();

		GigyaManager.getLoggedUserCached().then((u) => {
			var ch = u.data[Constants.CH_PROMO];
			if(typeof ch !== "undefined" && ch != null && ch != ""){
				$('#regulationAcceptance').remove();
			}

			this.userPrivacyProfiling = u.preferences.privacy_profiling.isConsentGranted;

			// termine ultimo per richiedere il premio
			this.promoApi.status().then((resp) => {
				let response = resp.body.response.data;

				let gamePlayOpened = response.gameplay.opened;
				this.openHour = parseInt(response.gameplay.hours.start.raw);
				this.closeHour = parseInt(response.gameplay.hours.end.raw);
				this.openDayTime = response.promo.dates.receipt_start_date.raw;
				this.closeDayTime = response.promo.dates.receipt_end_date.raw;

				if(gamePlayOpened === "false"){
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <p>${response.gameplay.opened_description}</p>
                                                            <a href="/promozioni/mulino-mattoncino/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
					$('.main-form').remove();
					this.removeLoader();
				} else if(moment(response.promo.dates.receipt_end_date.raw).diff(moment()) < 0){
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Il concorso è terminato!</h2>
                                                            <p>Ricorda, hai tempo fino alle 18.00 del 28.03.2022 per richiedere il tuo premio.</p>
                                                            <a href="/promozioni/mulino-mattoncino/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
					$('.main-form').remove();
					this.removeLoader();
				} else {
					this.alwaysOn = (this.openHour === 0 && this.closeHour === 23);
					if(!this.alwaysOn){
						let currentHours = new Date().getHours();
						let isOpened = currentHours >= this.openHour && currentHours < this.closeHour;
						let title = moment(response.promo.dates.receipt_end_date.raw).diff(moment(), 'days') >= 1 ? 'Torna domani!' : '';
						if(!isOpened){
							let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">${title}</h2>
                                                            <p>Il concorso è attivo dalle h.10:00 del 10.01.2022 alle 18:00 del 13.03.2022</p>
                                                            <a href="/promozioni/mulino-mattoncino/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
							$(this.element).append(tmplModalGeneric);
							this.loadChildComponents(this);
							$('.main-form').remove();
							this.removeLoader();
						}
					}
					if(this.productNumber > 1){
						$('#product2').parents(".pp-dropdown-cnt").show();
					}

					this.promoApi.elencoStore(false).then((result)=>{
						this.buildDropdownStore(result.body);
						this.promoApi.elencoProdotti().then((result)=>{
							this.productData = result.body;
							this.buildDropdownProduct(this.productData);
							this.removeLoader();
						})
					})

					$('#regione').change(()=>{
						this.startLoader();
						this.buildDropdownProvince($('#regione').val());
						this.removeLoader();
					});
				}
			});
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		})

		$.fn.datepicker.languages['it-IT'] = {
			format: 'dd/mm/yyyy',
			days: ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'],
			daysShort: ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'],
			daysMin: ['Do','Lu','Ma','Me','Gi','Ve','Sa'],
			weekStart: 1,
			months: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
			monthsShort: ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'],
			autoHide: true
		};
		$('[data-toggle="datepicker"]').datepicker(
			{
				language: 'it-IT',
				format: 'dd-mm-yyyy',
				startDate: new Date(2022,0,5),
				endDate: new Date()
			}
		);



		$('input[name="storeType"]').change(()=>{
			let val = $('input[name="storeType"]:checked').val();
			this.startLoader();
			this.promoApi.elencoStore(val != 'offline').then((result)=> {
				this.buildDropdownStore(result.body);
				this.removeLoader();
			});
		})

		//IMAGE VIEW
		$('#foto-scontrino').change(() => {
			var input =  $('#foto-scontrino')[0];
			let file = input.files[0];
			var maxSize = $(input).data('max-size');


			if (maxSize > file.size) {
				this.startLoader();

				this.promoApi.uploadFile(file, this.files.length == 0 ? 1 : 2).then((resp)=>{
					let data = resp.body;
					let filename_server = data.response.data.filename;
					let idx_file = filename_server.split(".")[0];
					var reader = new FileReader();
					reader.onload = function (e) {
						if (filename_server.match(/pdf$/)) {
							$('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img' +
                                ' src="/fe-web/img/icons/avatar_placeholder.jpg"></div><div' +
                                ' class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
						} else {
							$('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img src="' + e.target.result + '"></div><div class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
						}
					}
					reader.readAsDataURL(file);
					this.files.push(filename_server);
					if(this.files.length == 2){
						$('#foto-scontrino').prop("disabled", true);
						$('.carica-scontrino').addClass('disabled');
					}else{
						$('#foto-scontrino').prop("disabled", false);
						$('.carica-scontrino').removeClass('disabled');
					}
					$('#foto-scontrino').val('');
					this.removeLoader();
				}, () => {
					//TODO POPUP ERRORE
					$('#foto-scontrino').prop("disabled", false);
					$('.carica-scontrino').removeClass('disabled');
					$('#foto-scontrino').val('');
					this.removeLoader();
				})
			}else{
				$('#foto-scontrino').addClass('error');
				$('.custom-row--middle').append('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il file caricato è troppo grande</span>');
			}
		});

		$('#conferma').on('click', (e) => {
			e.preventDefault();
			this.submitForm();
		});
	}

	buildDropdownStore(stores){
		let options = '<option value="-" default="true">Scegli lo store</option>';

		let storeList = stores.response.data;
		for(var i = 0; i < storeList.length; i++){
			options += `<option value="${storeList[i].tag}">${storeList[i].description}</option>`
		}
		$('#market').html(options);

		if(storeList.length == 1){
			$('#market').val(storeList[0].tag);
			$('#market').hide();
			$('#market').next().hide();
		}else{
			$('#market').val("-");
		}
	}

	buildDropdownProduct(productData){
		let options = '';

		let productList = productData.response.data;
		for(var i = 0; i < productList.length; i++){
			options += `<option value="${productList[i].code}">${productList[i].description}</option>`
		}


		$('#product').html('<option value="0" default="true">Scegli il prodotto Numero1</option>'+options);
		//$('#product2').html('<option value="0" default="true">Scegli il prodotto Numero2</option>'+options);
		$('#product').val(0);
		//$('#product2').val(0);
	}

	async buildDropdownProvince(idRegion){
		let options = '<option value="" default="true">Scegli la provincia</option>';

		if(idRegion){
			let resp = await this.promoApi.elencoProvince(idRegion);
			let provinceList = resp.body.response.data;
			for(var i = 0; i < provinceList.length; i++){
				options += `<option value="${provinceList[i].id}" data-region-id="${provinceList[i].id}">${provinceList[i].description}</option>`
			}

			this.removeLoader();
		}



		$('#provincia').html(options);
		$('#provincia').val("");
	}

	async buildDropdownRegioni(){
		let options = '<option value="" default="true">Scegli la regione</option>';

		let resp = await this.promoApi.elencoRegioni("");
		let regionList = resp.body.response.data;
		for(var i = 0; i < regionList.length; i++){
			options += `<option value="${regionList[i].id}" data-region-id="${regionList[i].id}">${regionList[i].description}</option>`
		}

		$('#regione').html(options);
		$('#regione').val("");
	}

	submitForm(){
		this.startLoader();
		this.validateForm();
	}

	removeFile(idx){
		$('#'+idx).remove();
		for(let i = 0; i < this.files.length; i++ ){
			if(this.files[i].indexOf(idx) != -1){
				this.files.splice(i, 1);
			}
		}
		if(this.files.length == 2){
			$('#foto-scontrino').prop("disabled", true);
			$('.carica-scontrino').addClass('disabled');
		}else{
			$('#foto-scontrino').prop("disabled", false);
			$('.carica-scontrino').removeClass('disabled');
		}
	}

	// CHECK VALIDAZIONE
	validateForm(){
		console.log('entrato in validateForm');

		$('.error-feedback').remove();
		$('input, select').removeClass('error');

		var varStore = this.take_market();
		var varReceipt_product_code = this.take_product();
		var varReceipt_product_code2 = true;
		if(this.productNumber >1){
			varReceipt_product_code2 = this.take_product2();
		}
		/*
		var varReceipt_regione = this.take_regione();
		var varReceipt_provincia = this.take_provincia();*/



		var varReceipt_date = this.take_data();
		var varReceipt_hour = this.take_hours();
		var varReceipt_minutes = this.take_minutes();
		var varReceipt_number = this.take_numScontrino();
		var varReceipt_amount_euros = this.take_euro();
		var varReceipt_amount_cents = this.take_cent();
		var varAcceptance = this.take_acceptance();

		if(varReceipt_date && varReceipt_hour && varReceipt_minutes){
			let date = $('#dataCal').val();
			let arrDate = date.split('-');
			let day = arrDate[0];
			let month = arrDate[1];
			let year = arrDate[2];
			let hours = $('#hours').val();
			let minutes = $('#minutes').val();
			let isoDate = year + '-' + month + '-' + day;
			let isoDateTime = isoDate + ' ' + hours + ':' + minutes;
			// moment(isoDateTime).isBetween(this.openDayTime, this.closeDayTime)
			if(moment(isoDateTime).diff(moment()) > 0){
				$('#dataCal').addClass('error');
				$('.row-form--date').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! L’iniziativa è valida per gli acquisti effettuati dalle ore 00.01 del 10.01.2022 alle 18:00 del 13.03.2022.</span>');
				this.removeLoader();
				return false;
			}
		}


		var varFiles = this.files.length > 0;

		if(!varFiles){
			$('#foto-scontrino').addClass('error');
			$('.custom-row--middle').append('<span class="error-feedback"><span' +
                ' class="icon-error">!</span> Devi caricare almeno una foto dello scontrino!</span>');

			console.log('entrato in validateForm');
		}

		if(varStore && varReceipt_product_code && varReceipt_product_code2 && varReceipt_date && varReceipt_hour && varReceipt_minutes && varReceipt_number && varReceipt_amount_euros && varReceipt_amount_cents && varAcceptance && varFiles) {
			console.log('entrato in validateForm - valido');
			this.sendForm();
		} else {
			console.log('entrato in validateForm - non valido');
			this.removeLoader();
			return false;
		}
	}

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
		$('#conferma').prop("disabled", false).removeClass('disabled');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
		$('#conferma').prop("disabled", true).addClass('disabled');
	}
	//VALIDAZIONE SINGOLI CAMPI
	sendForm(){
		let market = $('#market').val();
		let product = $('#product').val();
		// let product2 = $('#product2').val();
		let date = $('#dataCal').val();
		let arrDate = date.split('-');
		let day = arrDate[0];
		let month = arrDate[1];
		let year = arrDate[2];
		let hours = $('#hours').val();
		let minutes = $('#minutes').val();
		let numScontrino = $('#numScontrino').val();
		let euro = $('#euro').val();
		let cent = $('#cent').val();

		// let regionId = $('#regione').val();
		// let provinceId = $('#provincia').val();

		let basedata = {
			receipt_product_code: product,
			receipt_day: day,
			receipt_month: month,
			receipt_year: year,
			receipt_minutes: minutes,
			receipt_hour: hours,
			receipt_number: numScontrino,
			receipt_amount_euros: euro,
			receipt_amount_cents: cent,
			receipt_file_front: this.files[0]
		}

		let customdata = {
			store: market,
			products: [{code: product, quantity:1}],
			user_profiling: this.userPrivacyProfiling ? 1 : 0,
			// prizeid: prizeId,
			// regionid: regionId,
			// provinceid:  provinceId
		}



		if(this.files.length > 1){
			basedata['receipt_file_back'] = this.files[1];
		}


		if($('#acceptance').length == 0){
			this.doPlayReceiptCall({basedata, customdata});
		}else{
			GigyaManager.addCH(Constants.CH_PROMO).then(()=>{
				this.doPlayReceiptCall({basedata, customdata}, true);
			}, (err)=>{
				console.log(err);
				let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Ti preghiamo di riprovare più tardi!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
				$(this.element).append(tmplModalGeneric);
				this.loadChildComponents(this);
				this.removeLoader();
			})
		}
	}

	doPlayReceiptCall(scontrino, flaggedCH){
		this.promoApi.giocaScontrino(scontrino).then((resp)=>{
			let data = resp.body;
			if(data.response.data.play.status == "WIN"){
				window.location.href='/promozioni/mulino-mattoncino/hai-vinto?pt='+data.response.data.play.token+"&pm=1";
			}else{
				window.location.href='/promozioni/mulino-mattoncino/non-hai-vinto';
			}
		},(resp) =>{
			this.removeLoader();
			if(flaggedCH){
				GigyaManager.removeCH(Constants.CH_PROMO);
			}
			let data = resp.body;
			let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto!</h2>
                                                            <p>${data.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
			$(this.element).append(tmplModalGeneric);
			this.loadChildComponents(this);
		})
	}

	take_market(){
		console.log('entrato in takeMarket');
		if( $('#market').length ){
			var market = $('#market').val();
			if (market.length < 2 & market !== undefined){
				$('#market').addClass('error');
				$('.row-form--market').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>');
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	take_product(){
		if( $('#product').length ){
			var product = $('#product').val();
			if (product.length < 2 & product !== undefined){
				$('#product').addClass('error');
				$('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto deve essere selezionato</span>');
			} else {
				var productArr = this.productData.response.data.map((o)=>o.code);
				if (productArr.indexOf(product) >= 0){
					return true;
				} else {
					$('#product').addClass('error');
					$('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto deve essere selezionato</span>');
				}
			}
		} else {
			return true;
		}
	}

	take_regione(){
		if( $('#regione').length ){
			var regione = $('#regione').val();
			if (regione.length == 0) {
				$('#regione').addClass('error');
				$('.row-form--where').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo regione deve essere selezionato</span>');
			}else {
				return true;
			}
		} else {
			return true;
		}
	}

	take_provincia(){
		if( $('#provincia').length ){
			var provincia = $('#provincia').val();
			if (provincia.length == 0) {
				$('#provincia').addClass('error');
				$('.row-form--where').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo provincia deve essere selezionato</span>');
			}else {
				return true;
			}
		} else {
			return true;
		}
	}

	take_product2(){
		if( $('#product2').length ){
			var product = $('#product2').val();
			if (product.length < 2 & product !== undefined){
				$('#product2').addClass('error');
				$('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto2 deve essere selezionato</span>');
			} else {
				var productArr = this.productData.response.data.map((o)=>o.code);
				if (productArr.indexOf(product) >= 0){
					return true;
				} else {
					$('#product2').addClass('error');
					$('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto2 deve essere selezionato</span>');
				}
			}
		} else {
			return true;
		}
	}

	take_data(){
		if( $('#dataCal').length ){
			var date = $('#dataCal').val();
			if (date.length < 2 & date !== undefined){
				$('#dataCal').addClass('error');
				$('.row-form--date').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo data deve essere selezionato</span>');
			} else {
				var arrDate = date.split('-');
				var day = arrDate[0];
				var month = arrDate[1];
				var year = arrDate[2];

				var startDate = '20220110';
				var endDate = '20220313';
				var selectedDate = year + month + day;
				if ( selectedDate >= startDate && selectedDate <= endDate ){
					return true;
				} else {
					$('#dataCal').addClass('error');
					$('.row-form--date').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! L’iniziativa è valida per gli acquisti  effettuati dal 10-01-2022 al 13-03-2022.</span>');
				}
			}
		} else {
			return true;
		}
	}

	take_hours(){
		if( $('#hours').length ){
			var hours = $('#hours').val();
			if (hours.length < 2 & hours !== undefined){
				$('#hours').addClass('error');
				$('.row-form--date').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo ore deve essere selezionato</span>');
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	take_minutes(){
		if( $('#minutes').length ){
			var minutes = $('#minutes').val();
			if (minutes.length < 2 & minutes !== undefined){
				$('#minutes').addClass('error');
				$('.row-form--date').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo minuti deve essere selezionato</span>');
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	take_numScontrino(){
		if( $('#numScontrino').length ){
			var numScontrino = $('#numScontrino').val();
			if (numScontrino.length < 1 & numScontrino !== undefined){
				$('#numScontrino').addClass('error');
				$('.row-form--scontrino').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Il numero dello scontrino caricato non è corretto</span>');
			} else {
				var validNum = this.numberReg.test(numScontrino);
				if (!validNum) {
					$('#numScontrino').addClass('error');
					$('.row-form--scontrino').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Il campo numero scontrino può contenere solo numeri!</span>');
				} else {
					return true;
				}
			}
		} else {
			return true;
		}
	}

	take_euro(){
		if( $('#euro').length ){
			var euro = $('#euro').val();
			if (euro.length < 1 & euro !== undefined) {
				$('#euro').addClass('error');
				$('.row-form--scontrino').append('<span class="error-feedback"><span class="icon-error">!</span>' +
                    ' Il campo euro deve essere compilato</span>');
			} else {
				var validNum = this.numberReg.test(euro);
				if (!validNum) {
					$('#euro').addClass('error');
					$('.row-form--scontrino').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Il campo euro non è corretto</span>');
				} else {
					return true;
				}
			}
		} else {
			return true;
		}
	}

	take_cent(){
		if( $('#cent').length ){
			var cent = $('#cent').val();
			if (cent.length < 1 & cent !== undefined) {
				$('#cent').addClass('error');
				$('.row-form--scontrino').append('<span class="error-feedback"><span class="icon-error">!</span>' +
                    ' Il campo centesimi deve essere compilato</span>');
			} else {
				var validCent = this.centReg.test(cent);
				if (!validCent) {
					$('#cent').addClass('error');
					$('.row-form--scontrino').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo centesimi non è corretto, controlla di aver digitato 2 cifre</span>');
				} else {
					return true;
				}
			}
		} else {
			return true;
		}
	}

	take_acceptance(){
		if( $('#acceptance').length ){
			if($('#acceptance').prop("checked") == false){
				$('#acceptance').addClass('error');
				$('.custom-row--acceptance').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Devi aver letto e accettato il regolamento.</span>');
			} else {
				return true;
			}
		} else {
			return true;
		}
	}
}

export default FormCtrl;
